define([
    "angular",
    "front-end-web-commons/app/nlgLGPD/nlgLGPD"
], function (angular) {
    "use strict";
    return angular.module("userManagementLGPDModule", ["userManagementModule", "nlgLGPDModule"]);
});